import ApiService, { errorMessage } from "helpers/ApiHelper";

const ROOT = "/api/v1/testimonials";

export { errorMessage };

/**
 * All testimonials for the admin, drafts included and in site order — unlike
 * the public read, which serves only published ones.
 */
export const fetchTestimonials = () => ApiService.request(ROOT, "get");

export const createTestimonial = (testimonial) => ApiService.request(ROOT, "post", testimonial);

export const updateTestimonial = (id, testimonial) =>
  ApiService.request(`${ROOT}/${id}`, "patch", testimonial);

/**
 * Publishing is deliberately separate from saving — the same split PromoBanners
 * and the page editors use: going live is a decision, and a save that could
 * publish by accident is the one mistake this screen must not allow.
 */
export const setTestimonialStatus = (id, status) =>
  ApiService.request(`${ROOT}/${id}/status`, "patch", { status });

export const deleteTestimonial = (id) => ApiService.request(`${ROOT}/${id}`, "delete");
